import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCountryTimeZone, getCurrency, getHourSlots } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment-timezone'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../Concierge/concierge.css'
import '../Concierge/concierge-responsive.css'
import Addons from './AddOns.js'
import Toggle from 'react-toggle'

import { CircularProgress } from '@material-ui/core'
import StandaloneCalendar from '../../common/CustomComponents/Calendar/StandaloneCalendar.js'

class ConciergeCruiseAdd extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      categoryList: [],
      category_id: '',
      cruiseList: [],
      cruise_id: '',
      destinationList: [],
      additionalHourList: [],
      destination_id: '',
      slots: [],
      date: moment().format('YYYY-MM-DD'),
      phone: '',
      email: '',
      coupon: '',
      country_code: '',
      slot: '',
      additional_hour: '',
      bookingData: {},
      calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
      calendarRange: { from: null, to: null },
      select_destination: {},
      isLoading: false,
      initialLoading: false,
      // Independent loading states
      isLoadingCategories: false,
      isLoadingCruises: false,
      isLoadingDestinations: false,
      isLoadingSlots: false,
      isLoadingCalendar: false,
      isLoadingAdditionalHours: false,
      isLoadingCruiseDetails: false,
      isBooking: false,
      // Validation errors
      emailError: '',
      cruise_search: '',
      cruise_title: '',
      calendar_slots: [],
      next_day_slots: [],
      slot_checked: [],
      calendarData: [],
      destination_drop: 0,
      additional_hour_drop: 0,
      popupOpen: false,
      cruiseDetails: {},
      facilities: [],
      filterOpen: false,
      number_of_guests: 0,
      filterCount: 0,
      addOnPopUp: 0,
      appOnData: {},
      cost_of_service: 0,
      isCustomerOptional: false,
      isCouponApplied: false,
      enable_b2b_prices: false,
      booking_date: '',
      filter_slots: [],
      available_filter_slots: [],
      filter_slot_range: { from: null, to: null },
    }
  }

  settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1, // Adjust based on your design
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  componentDidMount() {
    if (localStorage['user_role'] == 'concierge') {
      this.setState({ enable_b2b_prices: true })
    }

    this.getCategoryMaster()
    this.getFacilities()
    this.generateFilterSlots()

    this.setState({ initialLoading: true })
    setTimeout(() => {
      this.setState({ initialLoading: false })
    }, 3000)
  }

  // Inline loader component for independent section loading
  renderInlineLoader = (height = 100) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: height,
          width: '100%',
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #00547e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )
  }

  // Empty state component for better UI
  renderEmptyState = (iconType, title, subtitle = '') => {
    const getIconSvg = () => {
      switch (iconType) {
        case 'cruise':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
              <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76" />
              <path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6" />
              <path d="M12 10v4" />
              <path d="M12 2v3" />
            </svg>
          )
        case 'destination':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle
                cx="12"
                cy="10"
                r="3"
              />
            </svg>
          )
        case 'time':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          )
        case 'calendar':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                ry="2"
              />
              <line
                x1="16"
                y1="2"
                x2="16"
                y2="6"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="6"
              />
              <line
                x1="3"
                y1="10"
                x2="21"
                y2="10"
              />
            </svg>
          )
        default:
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              />
              <line
                x1="12"
                y1="8"
                x2="12"
                y2="12"
              />
              <line
                x1="12"
                y1="16"
                x2="12.01"
                y2="16"
              />
            </svg>
          )
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px dashed #dee2e6',
          marginTop: '15px',
          width: '100%',
          minHeight: '200px',
        }}
      >
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#e9ecef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
          }}
        >
          {getIconSvg()}
        </div>
        <h5
          style={{
            margin: '0 0 5px 0',
            fontSize: '16px',
            fontWeight: '600',
            color: '#495057',
          }}
        >
          {title}
        </h5>
        {subtitle && (
          <p
            style={{
              margin: 0,
              fontSize: '13px',
              color: '#6c757d',
              textAlign: 'center',
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    )
  }

  getCategoryMaster = () => {
    this.setState({ isLoadingCategories: true })

    axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          let categoryListCopy = res.data.data.filter(
            (category) => category.is_active === true && category.category_type == 'CRUISE'
          )

          this.setState(
            {
              categoryList: categoryListCopy,
              cruise_title: categoryListCopy[0].cruise_cat_en,
            },
            () => {
              if (categoryListCopy?.[0]?.id) {
                this.getCruiseList(categoryListCopy[0].id)
              }
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoadingCategories: false,
        })
      })
  }

  getFacilities = async () => {
    this.setState({ isLoading: true, facilities: [] })
    axios
      .get(Constant.getAPI() + `/admin/get-facilities/cruise`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            facilities: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getCruiseList = (category_id, keyword = '') => {
    this.setState(
      {
        category_id: category_id,
        isLoadingCruises: true,
        cruiseList: [],
        slotList: [],
        additionalHourList: [],
      },
      () => {
        let postParam = {
          category_id: category_id,
          keyword: keyword,
        }

        if (this.state.number_of_guests) {
          postParam = {
            ...postParam,
            number_of_guests: this.state.number_of_guests,
          }
        }

        if (this.state.booking_date) {
          postParam = {
            ...postParam,
            booking_date: this.state.booking_date,
          }

          this.setState({
            calendarDate: moment(this.state.booking_date).startOf('month').format('YYYY-MM-DD'),
            date: this.state.booking_date,
          })
        }

        if (this.state.filter_slot_range.from && this.state.filter_slot_range.to) {
          postParam = {
            ...postParam,
            slots: this.state.filter_slots,
          }
        }

        axios
          .post(Constant.getAPI() + '/cruise/get-cruise-list', postParam, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then((res) => {
            if (res.data.success) {
              this.setState(
                {
                  cruiseList: res.data.data?.cruises,
                  cruise_id: res.data.data?.cruises.length ? res.data.data?.cruises[0].id : '',
                },
                () => {
                  if (res.data.data?.cruises?.[0]?.id) {
                    this.getDestinationList(res.data.data?.cruises[0].id)
                  }
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoadingCruises: false,
            })
          })
      }
    )
  }

  getDestinationList = (cruise_id) => {
    this.setState(
      {
        cruise_id: cruise_id,
        destinationList: [],
        slotList: [],
        additionalHourList: [],
        isLoadingDestinations: true,
        additional_hour: '',
      },
      () => {
        axios
          .get(
            `${Constant.getAPI()}/booking/get-destination-list/${cruise_id}?is_b2b=${this.state.enable_b2b_prices}`,
            {
              headers: {
                'Allow-Control-Allow-Origin': '*',
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
              },
            }
          )
          .then(async (res) => {
            if (res.data.success) {
              this.setState(
                {
                  destinationList: res.data?.data?.destinationList,
                  destination_id:
                    res.data?.data?.destinationList.length > 0 ? res.data?.data?.destinationList[0].id : '',
                  select_destination:
                    res.data?.data?.destinationList.length > 0 ? res.data?.data?.destinationList[0] : '',
                },
                () => {
                  if (res.data?.data?.destinationList?.[0]) {
                    this.getSlots(res.data.data.destinationList[0])
                  }
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoadingDestinations: false,
            })
          })
      }
    )
  }

  getSlots = (destination) => {
    this.setState(
      {
        slots: [],
        select_destination: destination,
        destination_id: destination.id,
        isLoadingSlots: true,
        isLoadingCalendar: true,
        additional_hour: '',
      },
      () => {
        if (this.state.cruise_id && this.state.date && this.state.destination_id) {
          let date =
            moment(new Date(this.state.date)).startOf('M').format('YYYY-MM-DD') == this.state.calendarDate
              ? this.state.date
              : this.state.calendarDate

          const data = {
            cruise_id: this.state.cruise_id,
            date: moment(new Date(date)).format('MM/DD/YYYY'),
            destination_id: this.state.destination_id,
            is_b2b: this.state.enable_b2b_prices,
          }

          axios
            .post(Constant.getAPI() + '/booking/check-available-slots-v3/', data, {
              headers: {
                'Allow-Control-Allow-Origin': '*',
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
              },
            })
            .then(async (res) => {
              if (res.data.success) {
                const slotList = res.data?.data?.slotList || []
                const destinationMinHr = parseInt(destination?.destination_min_hour?.split(':')?.[0]) - 1
                const nextDaySlotList = res.data?.data?.nextDaySlots?.slice(0, destinationMinHr) || []

                const calendarSlotsArr = getHourSlots().reduce((acc, slot) => {
                  const hour = slot.value.split(':')[0]
                  if (hour !== '24') {
                    acc.push({
                      ...slot,
                      enable: slotList.includes(hour),
                      nextDay: false,
                      uniqueValue: this.state.date + ' ' + slot.value,
                      date: this.state.date,
                    })
                  }
                  return acc
                }, [])

                if (nextDaySlotList.length > 0) {
                  for (const slt of nextDaySlotList) {
                    calendarSlotsArr.push({
                      label: `${slt}:00`,
                      value: `${slt}:00:00`,
                      nextDay: true,
                      enable: true,
                      uniqueValue:
                        moment(this.state.date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD') + ` ${slt}:00:00`,
                      date: moment(this.state.date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD'),
                    })
                  }
                }
                this.setState(
                  {
                    slots: slotList,
                    calendar_slots: calendarSlotsArr,
                    next_day_slots: nextDaySlotList,
                    calendarData: res.data?.data?.calendarData,
                  },
                  () => {
                    this.setSlots(slotList?.[0])
                    this.getAdditionHours()
                  }
                )
              }
            })
            .catch((err) => {
              if (err?.response?.status === 401) {
                Constant.getAuthLogout()
              } else {
                Swal.fire({
                  title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                  icon: 'error',
                  text: '',
                  type: 'error',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ok',
                })
              }
            })
            .finally(() => {
              this.setState({
                isLoadingSlots: false,
                isLoadingCalendar: false,
              })
            })
        }
      }
    )
  }

  getAdditionHours = () => {
    this.setState(
      {
        additionalHourList: [],
        isLoadingAdditionalHours: true,
      },
      () => {
        let date =
          moment(new Date(this.state.date)).startOf('M').format('YYYY-MM-DD') == this.state.calendarDate
            ? this.state.date
            : this.state.calendarDate
        const data = {
          cruise_id: this.state.cruise_id,
          destination_id: this.state.destination_id,
          date: moment(date).format('MM/DD/YYYY'),
          is_b2b: this.state.enable_b2b_prices,
        }
        axios
          .post(`${Constant.getAPI()}/cruise/get-additional-hours`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then((res) => {
            if (res?.data?.success) {
              this.setState({
                additionalHourList: res.data.data,
              })
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoadingAdditionalHours: false,
            })
          })
      }
    )
  }

  // Email validation helper
  isValidEmail = (email) => {
    if (!email) return true // Empty is valid (optional field)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  handleChange = (event) => {
    event.persist()

    if (event.target.name == 'enable_b2b_prices') {
      this.setState(
        {
          enable_b2b_prices: event.target.checked,
        },
        () => {
          this.clearData()
          this.getCategoryMaster()
        }
      )

      return
    }

    if (event?.target?.name === 'cost_of_service') {
      if (event?.target?.value > -100) {
        this.setState({ [event?.target?.name]: event?.target?.value })
      }
    } else if (event?.target?.name === 'email') {
      // Validate email on change
      const value = event?.target?.value
      if (value && !this.isValidEmail(value)) {
        this.setState({ email: value, emailError: 'Please enter a valid email address' })
      } else {
        this.setState({ email: value, emailError: '' })
      }
    } else {
      this.setState({ [event?.target?.name]: event?.target?.value }, () => {
        if (event?.target?.name === 'category_id') {
          this.getCruiseList(event.target.value)
        }
        if (event?.target?.name === 'cruise_search') {
          this.getCruiseList(this.state.category_id, event.target.value)
        }
        if (event?.target?.name === 'cruise_id') {
          this.getDestinationList(event.target.value)
        }

        if (
          event?.target?.name === 'cruise_id' ||
          event?.target?.name === 'destination_id' ||
          event?.target?.name === 'date'
        ) {
          this.getSlots()
        }
      })
    }
  }

  handleCalendarDateSelect = (rangeObj) => {
    if (this.state.select_destination?.book_by === 'day') {
      this.setState({
        calendarRange: rangeObj,

        calendarDate: rangeObj.from,
        date: rangeObj.from,
      })
    } else {
      this.setState(
        {
          calendarDate: rangeObj,
          date: rangeObj,
        },
        () => {
          this.getSlots(this.state.select_destination)
        }
      )
    }
  }

  onBooking = async () => {
    if (!this.state.country_code && !this.state.isCustomerOptional) {
      Swal.fire('Country code required!', '', 'error')
      return
    }
    if (!this.state.phone && !this.state.isCustomerOptional) {
      Swal.fire('Contact Number required!', '', 'error')
      return
    }
    // Validate email format if provided
    if (this.state.email && !this.isValidEmail(this.state.email)) {
      Swal.fire('Please enter a valid email address!', '', 'error')
      return
    }
    if (!this.state.category_id) {
      Swal.fire('Category required!', '', 'error')
      return
    }
    if (!this.state.cruise_id) {
      Swal.fire('Cruise required!', '', 'error')
      return
    }
    if (!this.state.destination_id) {
      Swal.fire('Destination required!', '', 'error')
      return
    }

    let updatedSlots = ''

    if (this.state.select_destination?.book_by === 'hours') {
      if (!this.state.date) {
        Swal.fire('Date required!', '', 'error')
        return
      }
      if (!this.state.slot) {
        Swal.fire('Starting time required!', '', 'error')
        return
      }

      if (this.state.slot.length > 0) {
        const slotsArr = this.state.slot.split(',')
        const lastSlot = parseInt(slotsArr[slotsArr.length - 1], 10) + 1
        const slotToBeAdded = lastSlot < 10 ? `0${lastSlot}` : `${lastSlot}`
        updatedSlots = [...slotsArr, slotToBeAdded].join(',')
      }
    } else {
      if (!this.state.calendarRange.from || !this.state.calendarRange.to) {
        Swal.fire('Date required!', '', 'error')
        return
      }
    }

    const data = {
      phone: this.state.phone,
      email: this.state.email,
      country_code: this.state.country_code,
      cruise_id: this.state.cruise_id,
      destination_id: this.state.destination_id,
      slot: updatedSlots,
      additional_hour: this.state.additional_hour,
      coupon: this.state.coupon,
      cost_of_service: this.state.cost_of_service,
      is_b2b: this.state.enable_b2b_prices,
    }

    if (this.state.select_destination?.book_by === 'hours') {
      data.date = moment(this.state.date, 'YYYY-MM-DD').format('MM/DD/YYYY')
    } else {
      data.date = moment(this.state.calendarRange.from, 'YYYY-MM-DD').format('MM/DD/YYYY')
      data.date_to = moment(this.state.calendarRange.to, 'YYYY-MM-DD').format('MM/DD/YYYY')
    }

    this.setState({ isData: true, isBooking: true })

    await axios
      .post(Constant.getAPI() + '/booking/admin-cruise-book', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            bookingData: res.data.data,
          })
          if (res.data.data.storeTypes && res.data.data.storeTypes.length > 0) {
            let tabArray = []
            for (let item of res.data.data.storeTypes) {
              if (item.isAvailable) {
                tabArray.push(item)
              }
            }
            if (tabArray.length > 0) {
              this.setState({
                appOnData: {
                  id: res.data.data.id,
                  cruise_id: res.data.data.cruise_id,
                  cruise_data: res.data.data.cruise,
                  tab: tabArray,
                  enable_b2b_prices: this.state.enable_b2b_prices,
                },
                addOnPopUp: 1,
              })
            } else {
              this.paymentPopUp()
            }
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isData: false,
          isBooking: false,
        })
      })
  }

  onCheckout = async (data) => {
    this.setState({ isData: true, isBooking: true })

    await axios
      .post(Constant.getAPI() + '/booking/admin-cruise-checkout/', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            bookingData: res.data.data,
          })
          if (res.data.data.storeTypes && res.data.data.storeTypes.length > 0) {
            let tabArray = []
            for (let item of res.data.data.storeTypes) {
              if (item.isAvailable) {
                tabArray.push(item)
              }
            }
            if (tabArray.length > 0) {
              this.setState({
                appOnData: {
                  id: res.data.data.id,
                  cruise_id: res.data.data.cruise_id,
                  tab: tabArray,
                  title: this.state.cruise_title,
                  enable_b2b_prices: this.state.enable_b2b_prices,
                },
                addOnPopUp: 1,
              })
            } else {
              this.paymentPopUp()
            }
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isData: false,
          isBooking: false,
        })
      })
  }

  processPayment = async () => {
    this.setState({ isBooking: true })
    const body = {
      booking_id: this.state.bookingData?.id,
      is_b2b: this.state.enable_b2b_prices,
    }
    await axios
      .post(Constant.getAPI() + '/booking/process-payment', body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            title: 'Booking Success',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Booking Details',
          }).then(() => {
            window.location.href = `#/booking-ordering/${body.booking_id}`
          })
          this.clearData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isBooking: false,
        })
      })
  }

  cancelBooking = async () => {
    const body = {
      booking_id: this.state.bookingData?.id,
    }
    await axios
      .post(Constant.getAPI() + '/booking/cancel-admin-booking', body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.setState({
          addOnPopUp: 0,
        })
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  paymentPopUp = () => {
    Swal.fire({
      width: '700px',
      title: '<div>Payment Confirmation</div>',
      html: `
        <table>
          <tbody>
            <tr>
              <th>Cruise</th>
              <td style="text-align: left">${this.state.bookingData?.cruise?.cruise_name_en || '--'}</td></tr>
            <tr>
              <th>Destination</th>
              <td style="text-align: left">${this.state.bookingData?.booking_destination || '--'}</td></tr>
            <tr>
              <th>Booking Date</th>
              <td style="text-align: left">${this.state.bookingData?.booking_date || '--'}</td></tr>
            <tr>
              <th>Cruise Destination Amount</th>
              <td style="text-align: left">${this.state.bookingData?.paymentSummary?.destination_total || '--'} ${getCurrency(localStorage.getItem('countryShortName'))}</td></tr>
            <tr>
              <th>Additional Hours Total</th>
              <td style="text-align: left">${this.state.bookingData?.paymentSummary?.additional_hours_total ? this.state.bookingData?.paymentSummary?.additional_hours_total + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td>
            </tr>
            <tr>
              <th>Cost Of Service</th>
              <td style="text-align: left">${this.state.bookingData?.cost_of_service ? this.state.bookingData?.cost_of_service + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td>
            </tr>
            <tr>
              <th>Total Booking Amount</th>
              <td style="text-align: left">${this.state.bookingData?.paymentSummary?.total_booking_amount ? this.state.bookingData?.paymentSummary?.total_booking_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td></tr>
            <tr>
              <th>Coupon Applied Amount</th>
              <td style="text-align: left">${this.state.bookingData?.paymentSummary?.coupon_applied_amount ? this.state.bookingData?.paymentSummary?.coupon_applied_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td></tr>
            <tr>
              <th>VAT (${this.state.bookingData?.paymentSummary?.vat}%)</th>
              <td style="text-align: left">${this.state.bookingData?.paymentSummary?.vat_amount ? this.state.bookingData?.paymentSummary?.vat_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td></tr>
          </tbody>
        </table>
      `,
      confirmButtonText: 'Process Payment',
      denyButtonText: `Cancel`,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.processPayment()
      } else {
        this.cancelBooking()
      }
    })
  }

  onMonthChange = (newMonth) => {
    let today = moment().tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
    let selectedDate = newMonth >= today ? newMonth.format('YYYY-MM-DD') : today.format('YYYY-MM-DD')

    this.setState(
      {
        date: selectedDate,
        calendarDate: selectedDate,
        additional_hour: '',
      },
      () => {
        this.getSlots(this.state.select_destination)
      }
    )
  }

  getCruiseDetails = (cruiseId) => {
    this.setState({ isLoadingCruiseDetails: true, cruiseDetails: {} })
    if (cruiseId) {
      axios
        .get(Constant.getAPI() + `/cruise/get-cruise/${cruiseId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              cruiseDetails: res.data.data,
              popupOpen: !this.state.popupOpen,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({
            isLoadingCruiseDetails: false,
          })
        })
    }
  }

  clearData = () => {
    this.setState({
      emailError: '',
      phone: '',
      email: '',
      coupon: '',
      country_code: '',
      cost_of_service: 0,
      isCustomerOptional: false,
      isCouponApplied: false,
    })
  }

  setSlots = (slot, nextDay = false) => {
    const { select_destination, additional_hour, calendar_slots } = this.state
    const minTime = parseInt(select_destination.destination_min_hour?.split(':')?.[0]) || 0
    const index = calendar_slots.map((ele) => ele.label.split(':')[0]).indexOf(slot)
    const length = calendar_slots.length
    const bookedSlots = calendar_slots.filter((ele) => !ele.enable).map((ele) => ele.label.split(':')[0])

    // Calculate the total number of slots needed
    const totalSlotsNeeded = minTime + (parseInt(additional_hour?.split(':')?.[0]) || 0)

    // Check if the slots are within bounds
    if (index + totalSlotsNeeded <= length && !nextDay) {
      // Check if any of the slots in the range are booked
      for (let i = index; i < index + totalSlotsNeeded; i++) {
        if (bookedSlots.includes(!calendar_slots[i]?.nextDay && calendar_slots[i]?.label?.split(':')?.[0])) {
          this.setState({ slot: '', additional_hour: '', slot_checked: [] })
          return
        }
      }

      // If all slots in the range are available, create the SlotGroup
      let SlotGroup = slot
      for (let i = index + 1; i < index + totalSlotsNeeded; i++) {
        SlotGroup += ',' + calendar_slots[i]?.label?.split(':')?.[0]
      }
      const slotsGroupData = SlotGroup?.split(',') || []
      const slotChecked = []
      const indexOfLastSlot = slotsGroupData.indexOf('23')

      // Check if slots contain next day slot or not.
      if (indexOfLastSlot !== -1) {
        for (let index = indexOfLastSlot; index < slotsGroupData.length; index++) {
          if (parseInt(slotsGroupData[index]) > parseInt(slotsGroupData[index + 1])) {
            slotChecked.push(this.state.date + ` ${slotsGroupData[index]}:00:00`)
          } else {
            slotChecked.push(
              moment(this.state.date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD') +
              ' ' +
              `${slotsGroupData[index]}:00:00`
            )
          }
        }
        for (let index = 0; index < indexOfLastSlot + 1; index++) {
          slotChecked.push(this.state.date + ` ${slotsGroupData[index]}:00:00`)
        }
      } else {
        for (let index = 0; index < slotsGroupData.length; index++) {
          slotChecked.push(this.state.date + ` ${slotsGroupData[index]}:00:00`)
        }
      }
      this.setState({ slot: SlotGroup, slot_checked: slotChecked })
      return 1
    } else {
      this.setState({ slot: '', additional_hour: '', slot_checked: [] })
      return 0
    }
  }

  addHourInAdditional = (value) => {
    this.setState({ additional_hour: value }, async () => {
      let a = await this.setSlots(this.state.slot?.split(',')?.[0])
      if (!a) {
        Swal.fire('Time Slot Range not Available', '', 'error')
      }
    })
  }

  openPopup = async (cruiseId = '') => {
    if (cruiseId) {
      this.getCruiseDetails(cruiseId)
    } else {
      this.setState({
        popupOpen: !this.state.popupOpen,
      })
    }
  }

  guestCountChanges = (value) => {
    let count = this.state.number_of_guests + (value ? 1 : -1)
    if (count >= 0) {
      this.setState(
        {
          number_of_guests: count,
        },
        () => {
          // Update filter count when guest count changes
          this.updateFilterCount()
        }
      )
    }
  }

  // Generate available slots for filter popup
  generateFilterSlots = () => {
    const slots = []
    for (let i = 0; i < 24; i++) {
      const hour = i.toString().padStart(2, '0')
      slots.push({
        value: `${hour}:00`,
        label: moment(`${hour}:00`, 'HH:mm').format('hh:mm A'),
        hour: hour,
      })
    }
    this.setState({
      available_filter_slots: slots,
    })
  }

  // Handle slot selection in filter popup
  handleFilterSlotSelection = (slotValue) => {
    const { filter_slot_range, available_filter_slots } = this.state
    let updatedRange = { ...filter_slot_range }

    if (!filter_slot_range.from) {
      // First selection - set as 'from'
      updatedRange.from = slotValue
      updatedRange.to = null
    } else if (!filter_slot_range.to) {
      // Second selection - set as 'to' and create range
      const fromIndex = available_filter_slots.findIndex((slot) => slot.value === filter_slot_range.from)
      const toIndex = available_filter_slots.findIndex((slot) => slot.value === slotValue)

      if (fromIndex === toIndex) {
        // Same slot selected - clear selection
        updatedRange = { from: null, to: null }
      } else {
        // Different slot - create range
        updatedRange.to = slotValue

        // Ensure from is always the earlier time
        if (fromIndex > toIndex) {
          updatedRange.from = slotValue
          updatedRange.to = filter_slot_range.from
        }
      }
    } else {
      // Range already exists - start new selection
      updatedRange = { from: slotValue, to: null }
    }

    // Generate slots array from range
    let slotsArray = []
    if (updatedRange.from && updatedRange.to) {
      const fromIndex = available_filter_slots.findIndex((slot) => slot.value === updatedRange.from)
      const toIndex = available_filter_slots.findIndex((slot) => slot.value === updatedRange.to)

      for (let i = fromIndex; i <= toIndex; i++) {
        slotsArray.push(available_filter_slots[i].value)
      }
    } else if (updatedRange.from) {
      slotsArray = [updatedRange.from]
    }

    this.setState(
      {
        filter_slot_range: updatedRange,
        filter_slots: slotsArray,
      },
      () => {
        this.updateFilterCount()
      }
    )
  }

  // Clear all selected slots in filter
  clearFilterSlots = () => {
    this.setState(
      {
        filter_slots: [],
        filter_slot_range: { from: null, to: null },
      },
      () => {
        this.updateFilterCount()
      }
    )
  }

  updateFilterCount = () => {
    let count = 0
    if (this.state.number_of_guests) {
      count = count + 1
    }
    if (this.state.booking_date) {
      count = count + 1
    }
    if (this.state.filter_slots && this.state.filter_slots.length > 0) {
      count = count + 1
    }
    this.setState({
      filterCount: count,
    })
  }

  applyFliter = async (value) => {
    this.setState({ filterOpen: !this.state.filterOpen })
    if (!value) {
      await this.setState({
        number_of_guests: 0,
        booking_date: '',
        filter_slots: [],
        filter_slot_range: { from: null, to: null },
        calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
      })
    }

    // Only call API when applying filters, not when resetting
    if (value) {
      await this.getCruiseList(this.state.category_id)
    } else {
      await this.getCruiseList(this.state.category_id)
    }

    // Update filter count
    this.updateFilterCount()
  }

  // Handle booking date change from the new date picker
  onBookingDateChange = (event) => {
    const selectedDate = event.target.value
    this.setState(
      {
        booking_date: moment(selectedDate).format('YYYY-MM-DD'),
      },
      () => {
        this.updateFilterCount()
      }
    )
  }

  handleDataFromChild = (data) => {
    this.setState({ addOnPopUp: 0 })
    this.onCheckout(data)
  }

  selectCruise = (cruiseId) => {
    this.openPopup(cruiseId)
    this.getDestinationList(cruiseId)
  }

  validateCouponCode = () => {
    if (!this.state.coupon) {
      Swal.fire('Coupon code required!', '', 'error')
      return
    }
    this.setState({ isLoading: true, isCustomerOptional: false })

    let updatedSlots = ''

    if (this.state.slot.length > 0) {
      const slotsArr = this.state.slot.split(',')
      const lastSlot = parseInt(slotsArr[slotsArr.length - 1], 10) + 1
      const slotToBeAdded = lastSlot < 10 ? `0${lastSlot}` : `${lastSlot}`
      updatedSlots = [...slotsArr, slotToBeAdded].join(',')
    }

    const slotArrData = updatedSlots.split(',')

    const data = {
      cruise_id: this.state.cruise_id,
      booking_date: moment(this.state.date, 'YYYY-MM-DD').format('YYYY/MM/DD'),
      coupon: this.state.coupon,
      start_time: `${slotArrData?.[0]}:00`,
      end_time: `${slotArrData?.[slotArrData?.length - 1]}:00`,
    }
    axios
      .post(Constant.getAPI() + `/booking/verify-coupon`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const resp = res.data.data
          if (resp.amount_type == 'PERCENTAGE' && resp.coupon_amount == 100) {
            this.setState({
              isCustomerOptional: true,
            })
          }
          this.setState({
            isCouponApplied: true,
          })
          Swal.fire(res.data.message, '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  removeCouponCode = () => {
    this.setState({ coupon: '', isCouponApplied: false, isCustomerOptional: false })
  }

  handleRangeError = (errorType, message) => {
    Swal.fire({
      title: 'Selection Error',
      icon: 'warning',
      text: message,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    {(this.state.isLoading || this.state.initialLoading || this.state.isBooking) && (
                      <div className="loader-overlay">
                        <div className="loader"></div>
                      </div>
                    )}

                    <div className="App">
                      {this.state.popupOpen && (
                        <div
                          className="popup-backdrop"
                          onClick={() => this.openPopup()}
                        >
                          <div
                            className="popup-content"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              className="popup-close"
                              onClick={() => this.openPopup()}
                            >
                              <img
                                src="./assets/icon/concierge/close-black.svg"
                                alt=""
                              />
                            </button>
                            <div className="popupScroll">
                              {this.state.isLoadingCruiseDetails ? (
                                this.renderInlineLoader(300)
                              ) : (
                                <div className="popup-data">
                                  <div className="w-50">
                                    <div>
                                      <div className="slider-container">
                                        <Slider {...this.settings}>
                                          {this.state.cruiseDetails?.cruiseGallery?.map((ele) => {
                                            return (
                                              <div className="img-box">
                                                <img
                                                  src={
                                                    ele.gal_large_img
                                                      ? Constant.getImage() + ele.gal_large_img
                                                      : './assets/images/no_image.png'
                                                  }
                                                  alt=""
                                                  onError={({ currentTarget }) => {
                                                    currentTarget.src = './assets/images/no_image.png'
                                                  }}
                                                />
                                              </div>
                                            )
                                          })}
                                        </Slider>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-50">
                                    <div>
                                      <div className="product-details">
                                        <h2 className="m-0">{this.state.cruiseDetails?.cruise_name_en}</h2>

                                        {/* <div className='review-data'>
                            <ul>
                              <li><img src="./assets/icon/concierge/star.svg" alt="" /></li>
                              <li><img src="./assets/icon/concierge/star.svg" alt="" /></li>
                              <li><img src="./assets/icon/concierge/star.svg" alt="" /></li>
                              <li><img src="./assets/icon/concierge/star.svg" alt="" /></li>
                              <li><img src="./assets/icon/concierge/star.svg" alt="" /></li>
                            </ul>
                            <p className='m-0'>13 reviews</p>
                          </div> */}

                                        <div className="review-location">
                                          <p className="m-0">Pick up point:</p>
                                          <img
                                            src="./assets/icon/concierge/location-new.svg"
                                            alt=""
                                          />
                                          <h4 className="m-0">{this.state.cruiseDetails?.pickUp?.pickup_address_en}</h4>
                                        </div>

                                        <div className="details-guest">
                                          <div className="box">
                                            <img
                                              src="./assets/icon/concierge/user.svg"
                                              alt=""
                                            />
                                            <p className="m-0">Guests {this.state.cruiseDetails?.max_guests}</p>
                                          </div>
                                          <div className="box">
                                            <img
                                              src="./assets/icon/concierge/captain.svg"
                                              alt=""
                                            />
                                            <p className="m-0">{this.state.cruiseDetails?.captain?.first_name} </p>
                                            <h5 className="m-0">{this.state.cruiseDetails?.captain?.last_name}</h5>
                                          </div>
                                        </div>

                                        <div className="details-guest-room">
                                          <div className="box">
                                            <img
                                              src="./assets/icon/concierge/big-lounge.svg"
                                              alt=""
                                            />
                                            <p className="m-0">Big lounges {this.state.cruiseDetails?.big_lounges}</p>
                                          </div>
                                          <div className="box">
                                            <img
                                              src="./assets/icon/concierge/bedroom.svg"
                                              alt=""
                                            />
                                            <p className="m-0">Bedrooms {this.state.cruiseDetails?.bedrooms} </p>
                                          </div>
                                          <div className="box">
                                            <img
                                              src="./assets/icon/concierge/toilets.svg"
                                              alt=""
                                            />
                                            <p className="m-0">Toilets {this.state.cruiseDetails?.toilets} </p>
                                          </div>
                                        </div>
                                        {this.state.cruiseDetails?.cruise_facilities?.length > 0 && (
                                          <div className="comfort-data">
                                            <h4 className="m-0">Comfort Facilities</h4>
                                            <div className="comfort-cat">
                                              {this.state.facilities
                                                ?.filter((ele) =>
                                                  this.state.cruiseDetails?.cruise_facilities?.includes(ele.id)
                                                )
                                                .map((flt) => {
                                                  return (
                                                    <div className="box">
                                                      <div className="card-shadow">
                                                        <img
                                                          src={Constant.getImage() + flt.image}
                                                          alt=""
                                                        />
                                                      </div>
                                                      <p className="m-0">{flt.name_en}</p>
                                                    </div>
                                                  )
                                                })}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* <button type='button' className='select-btn'>Select</button> */}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Filter popup */}
                      {this.state.filterOpen && (
                        <div
                          className="popup-backdrop"
                          onClick={() =>
                            this.setState({
                              filterOpen: !this.state.filterOpen,
                            })
                          }
                        >
                          <div
                            className="popup-content filter-popup-content"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              className="popup-close"
                              onClick={() =>
                                this.setState({
                                  filterOpen: !this.state.filterOpen,
                                })
                              }
                            >
                              <img
                                src="./assets/icon/concierge/close-black.svg"
                                alt="Close"
                              />
                            </button>
                            <div className="popupScroll">
                              <div className="filter-popup-header">
                                <div className="filter-icon-header">
                                  <img
                                    src="./assets/icon/concierge/filter-icon.svg"
                                    alt="Filter"
                                    className="filter-main-icon"
                                  />
                                </div>
                                <h2 className="text-heading filter-main-title">Filter Options</h2>
                                <p className="filter-subtitle">Refine your search to find the perfect cruise</p>
                              </div>

                              <div className="filter-sections">
                                {/* Booking Date Section */}
                                <div className="filter-section">
                                  <div className="filter-section-header">
                                    <div className="filter-section-icon">
                                      <img
                                        src="./assets/icon/concierge/clock.svg"
                                        alt="Date"
                                        className="filter-icon"
                                      />
                                    </div>
                                    <div className="filter-section-info">
                                      <h3 className="filter-section-title">Booking Date</h3>
                                      <p className="filter-section-description">Select your preferred date</p>
                                    </div>
                                  </div>
                                  <div className="filter-section-content">
                                    <div className="date-input-wrapper">
                                      <input
                                        type="date"
                                        className="form-control date-input"
                                        name="booking_date_filter"
                                        id="booking_date_filter"
                                        value={this.state.booking_date}
                                        onChange={this.onBookingDateChange}
                                        min={moment().format('YYYY-MM-DD')}
                                        placeholder="Select date"
                                      />
                                      {this.state.booking_date && (
                                        <button
                                          className="clear-date-btn"
                                          onClick={() =>
                                            this.setState({ booking_date: '' }, () => this.updateFilterCount())
                                          }
                                          title="Clear date"
                                        >
                                          <img
                                            src="./assets/icon/concierge/close-black.svg"
                                            alt="Clear"
                                          />
                                        </button>
                                      )}
                                    </div>
                                    {this.state.booking_date && (
                                      <div className="filter-value-display">
                                        <span className="filter-value-label">Selected:</span>
                                        <span className="filter-value-text">
                                          {moment(this.state.booking_date).format('MMMM DD, YYYY')}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Starting Time Slots Section */}
                                <div className="filter-section">
                                  <div className="filter-section-header">
                                    <div className="filter-section-icon">
                                      <img
                                        src="./assets/icon/concierge/clock.svg"
                                        alt="Time"
                                        className="filter-icon"
                                      />
                                    </div>
                                    <div className="filter-section-info">
                                      <h3 className="filter-section-title">Starting Time</h3>
                                      <p className="filter-section-description">
                                        Select time range (click first time, then second time)
                                      </p>
                                    </div>
                                  </div>
                                  <div className="filter-section-content">
                                    <div className="filter-slots-container">
                                      <div className="filter-slots-header">
                                        <div className="filter-slots-info">
                                          <span className="filter-slots-count">
                                            {this.state.filter_slots.length > 0
                                              ? this.state.filter_slot_range.to
                                                ? `${this.state.filter_slots.length} slots selected (${this.state.filter_slot_range.from} - ${this.state.filter_slot_range.to})`
                                                : `1 slot selected (${this.state.filter_slot_range.from})`
                                              : 'No slots selected'}
                                          </span>
                                        </div>
                                        {this.state.filter_slots.length > 0 && (
                                          <button
                                            className="filter-clear-slots-btn"
                                            onClick={this.clearFilterSlots}
                                            title="Clear all selected slots"
                                          >
                                            <img
                                              src="./assets/icon/concierge/close-black.svg"
                                              alt="Clear"
                                            />
                                            Clear All
                                          </button>
                                        )}
                                      </div>
                                      <div className="filter-slots-grid">
                                        {this.state.available_filter_slots.map((slot) => {
                                          const isSelected = this.state.filter_slots.includes(slot.value)
                                          const isFromSlot = this.state.filter_slot_range.from === slot.value
                                          const isToSlot = this.state.filter_slot_range.to === slot.value
                                          const isInRange = this.state.filter_slots.includes(slot.value)

                                          let slotClass = 'filter-slot-item'
                                          if (isFromSlot) {
                                            slotClass += ' filter-slot-from'
                                          } else if (isToSlot) {
                                            slotClass += ' filter-slot-to'
                                          } else if (isInRange) {
                                            slotClass += ' filter-slot-range'
                                          }

                                          return (
                                            <div
                                              key={slot.value}
                                              className={slotClass}
                                              onClick={() => this.handleFilterSlotSelection(slot.value)}
                                              title={`${slot.label} - Click to ${isSelected ? 'deselect' : 'select'}`}
                                            >
                                              <div className="filter-slot-time">{slot.label}</div>
                                              <div className="filter-slot-indicator">
                                                {isFromSlot && (
                                                  <span className="filter-slot-label from-label">FROM</span>
                                                )}
                                                {isToSlot && <span className="filter-slot-label to-label">TO</span>}
                                                {isInRange && !isFromSlot && !isToSlot && (
                                                  <div className="filter-slot-range-indicator"></div>
                                                )}
                                              </div>
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </div>
                                    {this.state.filter_slots.length > 0 && (
                                      <div className="filter-value-display">
                                        <span className="filter-value-label">Selected Range:</span>
                                        <div className="filter-selected-slots">
                                          <span className="filter-range-display">
                                            {this.state.filter_slot_range.from && this.state.filter_slot_range.to
                                              ? `${this.state.filter_slot_range.from} - ${this.state.filter_slot_range.to} (${this.state.filter_slots.length} slots)`
                                              : this.state.filter_slot_range.from}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Number of Guests Section */}
                                <div className="filter-section">
                                  <div className="filter-section-header">
                                    <div className="filter-section-icon">
                                      <img
                                        src="./assets/icon/concierge/user.svg"
                                        alt="Guests"
                                        className="filter-icon"
                                      />
                                    </div>
                                    <div className="filter-section-info">
                                      <h3 className="filter-section-title">Number of Guests</h3>
                                      <p className="filter-section-description">
                                        Specify guest count for better results
                                      </p>
                                    </div>
                                  </div>
                                  <div className="filter-section-content">
                                    <div className="guest-counter">
                                      <button
                                        className="counter-btn counter-btn-decrease"
                                        onClick={() => this.guestCountChanges(0)}
                                        disabled={this.state.number_of_guests <= 0}
                                        title="Decrease guests"
                                      >
                                        <span>−</span>
                                      </button>
                                      <div className="counter-display">
                                        <span className="counter-number">{this.state.number_of_guests}</span>
                                        <span className="counter-label">
                                          {this.state.number_of_guests === 1 ? 'Guest' : 'Guests'}
                                        </span>
                                      </div>
                                      <button
                                        className="counter-btn counter-btn-increase"
                                        onClick={() => this.guestCountChanges(1)}
                                        title="Increase guests"
                                      >
                                        <span>+</span>
                                      </button>
                                    </div>
                                    {this.state.number_of_guests > 0 && (
                                      <div className="filter-value-display">
                                        <span className="filter-value-label">Selected:</span>
                                        <span className="filter-value-text">
                                          {this.state.number_of_guests}{' '}
                                          {this.state.number_of_guests === 1 ? 'Guest' : 'Guests'}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Action Buttons */}
                              <div className="filter-actions">
                                <button
                                  type="button"
                                  className="btn filter-reset-btn"
                                  onClick={() => this.applyFliter(0)}
                                  disabled={this.state.filterCount === 0}
                                >
                                  <span className="btn-icon-text">↻</span>
                                  Reset All
                                </button>
                                <button
                                  type="button"
                                  className="btn book-btn filter-apply-btn"
                                  onClick={() => this.applyFliter(1)}
                                >
                                  <span className="btn-icon-text">✓</span>
                                  Apply Filters
                                  {this.state.filterCount > 0 && (
                                    <span className="filter-count-badge">{this.state.filterCount}</span>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Filter popup */}
                      {!!this.state.addOnPopUp && (
                        <div
                          className="popup-backdrop"
                          onClick={() =>
                            this.setState(
                              {
                                isLoading: true,
                              },
                              () => {
                                this.cancelBooking()
                              }
                            )
                          }
                        >
                          <div
                            className="popup-content-2 p-0"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="h-100 position-relative">
                              {this.state.isLoading && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: 1000,
                                  }}
                                >
                                  {this.renderInlineLoader(100)}
                                </div>
                              )}
                              <button
                                className="popup-close"
                                onClick={() =>
                                  this.setState(
                                    {
                                      isLoading: true,
                                    },
                                    () => {
                                      this.cancelBooking()
                                    }
                                  )
                                }
                                disabled={this.state.isLoading}
                              >
                                <img
                                  src="./assets/icon/concierge/close-black.svg"
                                  alt=""
                                />
                              </button>
                              <Addons
                                data={this.state.appOnData}
                                handleDataFromChild={this.handleDataFromChild}
                                clearData={this.clearData}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Page Title with B2B Toggle */}
                    <div
                      style={{
                        marginBottom: 25,
                        paddingBottom: 15,
                        border: '2px solid #00547e',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        alignContent: 'center',
                      }}
                    >
                      <h1
                        style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#00547e',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          margin: 0,
                        }}
                      >
                        <i
                          className="icofont icofont-ship"
                          style={{ marginRight: '10px', fontSize: '28px' }}
                        ></i>
                        {this.state.cruise_title || 'Cruise'} Booking
                      </h1>
                      {localStorage['user_role'] != 'concierge' && (
                        <div
                          style={{
                            display: 'flex',
                            width: '250px',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <label style={{ width: '150px', fontWeight: '600', marginBottom: 0 }}>
                            Enable B2B Prices
                          </label>
                          <Toggle
                            className="w-25"
                            name="enable_b2b_prices"
                            id="enable_b2b_prices"
                            icons={false}
                            onChange={this.handleChange}
                            checked={this.state.enable_b2b_prices}
                          />
                        </div>
                      )}
                    </div>

                    <div>
                      <div className="">
                        <div className="card-padding">
                          <h2 className="text-heading">Category</h2>
                          <div
                            className="category-data mt-3 p-2"
                            style={{ backgroundColor: '#f9f9f9' }}
                          >
                            {this.state.categoryList?.map((category) => (
                              <div
                                key={category.id}
                                className={
                                  (this.state.category_id == category.id ? 'select-list' : '') + ' category-list'
                                }
                                style={{ boxShadow: '0 0px 4px rgba(0, 0, 0, 0.1)' }}
                                onClick={() => {
                                  this.setState({ cruise_title: category.cruise_cat_en }, () => {
                                    this.getCruiseList(category.id)
                                  })
                                }}
                              >
                                <div className="text-center p-2">
                                  <img
                                    style={{ width: '100px', height: '100px' }}
                                    src={
                                      category.cruise_cat_img !== undefined && category.cruise_cat_img !== null
                                        ? Constant.getImage() + category.cruise_cat_img
                                        : './assets/images/no_image.png'
                                    }
                                    alt=""
                                    onError={({ currentTarget }) => {
                                      currentTarget.src = './assets/images/no_image.png'
                                    }}
                                  />
                                </div>
                                <p className="py-2 m-0">{category.cruise_cat_en}</p>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="mt-20">
                          <div className="yacht-title mb-1">
                            <h2 className="text-heading">All {this.state.cruise_title}</h2>
                            <div className="contact-in contact-second">
                              <div>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="cruise_search"
                                  id="cruise_search"
                                  placeholder={`Search yacht and Boat`}
                                  onChange={this.handleChange}
                                  value={this.state.cruise_search}
                                  style={{ borderRadius: '10px' }}
                                />
                              </div>
                              <div className="position-relative filter-width">
                                <div
                                  className="filter"
                                  onClick={() =>
                                    this.setState({
                                      filterOpen: !this.state.filterOpen,
                                    })
                                  }
                                >
                                  <img
                                    src="./assets/icon/concierge/filter-icon.svg"
                                    alt="Filter"
                                  />
                                  <p className="m-0">Filter</p>
                                  {this.state.filterCount > 0 && (
                                    <span className="filter-count-indicator">{this.state.filterCount}</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="yachts-data"
                            style={{ backgroundColor: '#f9f9f9', padding: '10px' }}
                          >
                            {this.state.isLoadingCruises
                              ? this.renderInlineLoader(150)
                              : this.state.cruiseList.map((cruise, i) => (
                                <div
                                  key={i}
                                  className={
                                    (this.state.cruise_id == cruise.id ? 'select-list' : '') + ' yachts-list'
                                  }
                                  style={{ overflow: 'hidden' }}
                                >
                                  <div
                                    className="text-center"
                                    onClick={() => this.selectCruise(cruise.id)}
                                  >
                                    <img
                                      style={{ width: '100px', height: '100px' }}
                                      src={
                                        cruise.cruise_thumb_img !== undefined && cruise.cruise_thumb_img !== null
                                          ? Constant.getImage() + cruise.cruise_thumb_img
                                          : './assets/images/no_image.png'
                                      }
                                      alt=""
                                      onError={({ currentTarget }) => {
                                        currentTarget.src = './assets/images/no_image.png'
                                      }}
                                    />
                                  </div>
                                  <div
                                    onClick={() => this.getDestinationList(cruise.id)}
                                    key={cruise.id}
                                  >
                                    <h4 className="m-0 head-name">{cruise.cruise_name}</h4>
                                    <p className="m-0 price-data">
                                      Starting from {cruise.cruise_price}{' '}
                                      {getCurrency(localStorage.getItem('countryShortName'))} (
                                      {cruise.formatted_minimum_booking_time})
                                    </p>
                                    <div className="list-details">
                                      <div className="entry-data">
                                        <img
                                          src="./assets/icon/concierge/user.svg"
                                          alt=""
                                        />
                                        <p className="m-0">{cruise.max_guests} Guests</p>
                                      </div>
                                      <div className="entry-star">
                                        <img
                                          src="./assets/icon/concierge/star.svg"
                                          alt=""
                                        />
                                        <p className="m-0">({Number(cruise.rating).toFixed(2)})</p>
                                      </div>
                                      <div className="entry-star">
                                        <img
                                          src="./assets/icon/concierge/clock.svg"
                                          alt=""
                                        />
                                        <p className="m-0">
                                          {parseInt(cruise.minimum_booking_time?.split(':')?.[0])} hrs
                                        </p>
                                      </div>
                                    </div>
                                    <div className="location-data">
                                      <img
                                        src="./assets/icon/concierge/location.svg"
                                        alt=""
                                      />
                                      <p className="m-0">{cruise.pickup_address}</p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {!this.state.isLoadingCruises &&
                              this.state.cruiseList.length == 0 &&
                              this.renderEmptyState(
                                'cruise',
                                `No ${this.state?.cruise_title || 'Item'} available`,
                                'Please select a different category'
                              )}
                          </div>
                        </div>
                      </div>
                      {this.state.cruiseList.length > 0 && (
                        <div className="mt-20">
                          <div className="booking-data">
                            <div>
                              <h2 className="text-heading">Booking</h2>
                              {this.state.isLoadingCalendar
                                ? this.renderInlineLoader(200)
                                : (() => {
                                  let unavailableDates = this.state.calendarData
                                    .filter((itm) => !itm.enable)
                                    .map((itm) => itm.date)
                                  let labelsForDates = this.state.calendarData.reduce((acc, item) => {
                                    acc[item.date] = item?.price ? [`${item?.price} KWD`] : []
                                    if (!item?.price) {
                                      unavailableDates.push(item.date)
                                    }
                                    return acc
                                  }, {})

                                  return this.state.calendarData.length > 0 ? (
                                    <StandaloneCalendar
                                      mode={this.state.select_destination?.book_by === 'day' ? 'range' : 'single'}
                                      labelsForDates={labelsForDates}
                                      unavailableDates={unavailableDates}
                                      onChange={this.handleCalendarDateSelect}
                                      onMonthChange={this.onMonthChange}
                                      onRangeError={this.handleRangeError}
                                      {...(this.state.select_destination?.book_by === 'day'
                                        ? {
                                          minDays: parseInt(this.state.select_destination.min_days) || 1,
                                          maxDays: parseInt(this.state.select_destination.max_days) || 30,
                                        }
                                        : {
                                          initialSelectedDate: this.state.date,
                                          persistSelectedDate: true,
                                        })}
                                    />
                                  ) : (
                                    <div className="card">
                                      <div className="card-body">
                                        <CircularProgress style={{ color: '#000846' }} />
                                      </div>
                                    </div>
                                  )
                                })()}
                            </div>
                            <div>
                              <div>
                                <h2 className="text-heading">Destination</h2>

                                {this.state.isLoadingDestinations ? (
                                  this.renderInlineLoader(100)
                                ) : this.state.destinationList.length > 0 ? (
                                  <div className="position-relative">
                                    <div
                                      id="accordion"
                                      role="tablist"
                                    >
                                      <div
                                        className="position-relative"
                                        onClick={() =>
                                          this.setState({ destination_drop: !this.state.destination_drop })
                                        }
                                      >
                                        <div>
                                          <div className="collapsed card-shadow p-3 d-flex justify-content-between align-items-center rounded ">
                                            <div className="d-flex gap-10 align-items-center">
                                              <div className="location-icon">
                                                <img
                                                  src="./assets/icon/concierge/location-new.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div className="location-in">
                                                <h3 className="m-0">
                                                  {this.state.select_destination.destination_address}
                                                  <span style={{ color: '#999' }}>
                                                    (Book by - {this.state.select_destination.book_by})
                                                  </span>
                                                </h3>
                                                {this.state.select_destination.book_by == 'hours' ? (
                                                  <p className="m-0">
                                                    {parseInt(
                                                      this.state.select_destination.destination_min_hour?.split(
                                                        ':'
                                                      )?.[0]
                                                    )}{' '}
                                                    hour
                                                  </p>
                                                ) : (
                                                  <p className="m-0 d-flex flex-column">
                                                    <span>
                                                      Check-in time - {this.state.select_destination.check_in_time} |
                                                      Check-out time - {this.state.select_destination.check_out_time}
                                                    </span>
                                                    <span>
                                                      Min day - {this.state.select_destination.min_days} | Max day -{' '}
                                                      {this.state.select_destination.max_days}
                                                    </span>
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            <div className="arrow">
                                              <img
                                                src="./assets/icon/concierge/arrow-up.svg"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {this.state.destination_drop ? (
                                          <div>
                                            <div className="destination p-3 card-shadow">
                                              {this.state.destinationList.map((destination) => (
                                                <div
                                                  key={destination.id}
                                                  className={
                                                    (destination.id == this.state.destination_id
                                                      ? 'destination-select'
                                                      : '') + ' destination-data'
                                                  }
                                                  onClick={() => this.getSlots(destination)}
                                                >
                                                  <div className="d-flex justify-content-between align-items-center gap-10">
                                                    {destination.book_by == 'hours' ? (
                                                      <div>
                                                        <h1 className="m-0">
                                                          {destination.destination_address}
                                                          <span style={{ color: '#999' }}>
                                                            (Book by - {destination.book_by})
                                                          </span>
                                                        </h1>
                                                        <p className="m-0">
                                                          {parseInt(destination.destination_min_hour?.split(':')?.[0])}{' '}
                                                          hours
                                                        </p>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <h1 className="m-0">
                                                          {destination.destination_address}
                                                          <span style={{ color: '#999' }}>
                                                            (Book by - {destination.book_by})
                                                          </span>
                                                        </h1>
                                                        <p className="m-0 d-flex flex-column">
                                                          <span>
                                                            Check-in time - {destination.check_in_time} | Check-out time
                                                            - {destination.check_out_time}
                                                          </span>
                                                          <span className="text-left">
                                                            Min day - {destination.min_days} | Max day -{' '}
                                                            {destination.max_days}
                                                          </span>
                                                        </p>
                                                      </div>
                                                    )}

                                                    <div className="text-center">
                                                      <h5 className="m-0">Starting Form</h5>
                                                      <span className="m-0">
                                                        {destination.price}{' '}
                                                        {getCurrency(localStorage.getItem('countryShortName'))}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  this.renderEmptyState(
                                    'destination',
                                    'No destination available',
                                    'Please select a different cruise'
                                  )
                                )}
                              </div>
                              {this.state.select_destination.book_by == 'hours' && (
                                <div className="mt-4">
                                  <h2 className="text-heading">Starting Time</h2>
                                  <div>
                                    {this.state.isLoadingSlots ? (
                                      this.renderInlineLoader(80)
                                    ) : this.state.slots.length > 0 ? (
                                      <div className="mt-3 time-data">
                                        {this.state.calendar_slots.map((slot) => (
                                          <span
                                            key={slot.uniqueValue}
                                            style={{}}
                                            className={
                                              !slot.nextDay
                                                ? slot.enable
                                                  ? (this.state.slot_checked?.includes(slot.uniqueValue)
                                                    ? 'slot-select'
                                                    : '') + ' time-list'
                                                  : 'time-list-disable'
                                                : slot.enable
                                                  ? (this.state.slot_checked?.includes(slot.uniqueValue)
                                                    ? 'slot-select'
                                                    : '') + ' time-list-next-day'
                                                  : 'time-list-next-day time-list'
                                            }
                                            onClick={() => this.setSlots(slot.label.split(':')[0], slot.nextDay)}
                                          >
                                            {moment(slot.label, 'HH:mm').format('hh:mm A')}
                                          </span>
                                        ))}
                                      </div>
                                    ) : (
                                      this.renderEmptyState(
                                        'time',
                                        'No slots available',
                                        'Please select a different date'
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="flex-d gap-20 mt-3">
                        {this.state.select_destination.book_by == 'hours' && (
                          <div className="w-100">
                            <div
                              className="additionl-box"
                              onClick={() => this.setState({ additional_hour_drop: !this.state.additional_hour_drop })}
                            >
                              <label className="col-form-label colformlabel">Additional Hours</label>
                              <div className="count-data">
                                {/* <span className='box' onClick={() => this.setState({ additional_hour: '' }, () => { this.setSlots(this.state.slot?.split(',')?.[0]) })}>
                        -
                      </span> */}
                                <div>
                                  {this.state.additionalHourList.length > 0
                                    ? parseInt(this.state.additional_hour?.split(':')?.[0])
                                      ? parseInt(this.state.additional_hour?.split(':')?.[0]) + ' Hours'
                                      : ''
                                    : 'No Additional Hours'}
                                </div>
                                <div className="arrow">
                                  <img
                                    src="./assets/icon/concierge/arrow-up.svg"
                                    alt=""
                                  />
                                </div>
                                {/* <span className='box'>
                        +
                      </span> */}
                              </div>
                            </div>
                            {this.state.additional_hour_drop && this.state.additionalHourList.length ? (
                              <div
                                onClick={() =>
                                  this.setState({ additional_hour_drop: !this.state.additional_hour_drop })
                                }
                              >
                                <div className="destination p-3 card-shadow">
                                  {this.state.additionalHourList.map((addHour) => (
                                    <div
                                      key={addHour.id}
                                      className={
                                        (parseInt(addHour.additional_hour?.split(':')?.[0]) ==
                                          this.state.additional_hour
                                          ? 'destination-select'
                                          : '') + ' destination-data'
                                      }
                                      onClick={() => this.addHourInAdditional(addHour.additional_hour)}
                                    >
                                      <div className="d-flex justify-content-between align-items-center gap-10">
                                        <div>
                                          <h1 className="m-0">
                                            {parseInt(addHour.additional_hour?.split(':')?.[0])} Hours
                                          </h1>
                                        </div>
                                        <div className="text-center">
                                          <span className="m-0">
                                            {addHour.price} {getCurrency(localStorage.getItem('countryShortName'))}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        <div className="w-100">
                          <div className="additionl-box">
                            <label className="col-form-label colformlabel w-100">Cost Of Service</label>
                            <input
                              type="number"
                              // min={0}
                              className="form-control border-radius"
                              name="cost_of_service"
                              id="cost_of_service"
                              placeholder={`Cost Of Service`}
                              onChange={this.handleChange}
                              value={this.state.cost_of_service}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex-d gap-20">
                        <div className="w-100 mt-3">
                          <div className="additionl-box">
                            <label className="col-form-label colformlabel w-100">
                              Customer Number {this.state.isCustomerOptional ? '(Optional)' : ''}
                            </label>
                            <div className="d-flex form-control contact-filed border-radius">
                              <input
                                style={{ width: '40%' }}
                                type="text"
                                className="border-none input-border"
                                name="country_code"
                                id="country_code"
                                placeholder={`Country Code`}
                                onChange={this.handleChange}
                                value={this.state.country_code}
                              />
                              <input
                                type="text"
                                className="form-control border-none"
                                style={{ width: '60%' }}
                                name="phone"
                                id="phone"
                                placeholder={`Contact Number`}
                                onChange={this.handleChange}
                                value={this.state.phone}
                                maxLength={10}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-100 mt-3">
                          <div className="additionl-box">
                            <label className="col-form-label colformlabel w-100">Coupon code</label>
                            <div
                              className="input-group d-flex"
                              style={{ marginBottom: '0', overflow: 'hidden' }}
                            >
                              <input
                                type="text"
                                className="form-control border-radius"
                                name="coupon"
                                id="coupon"
                                placeholder="Coupon Code"
                                onChange={this.handleChange}
                                value={this.state.coupon}
                                style={{ borderRight: '0' }}
                                disabled={this.state.isCouponApplied}
                              />
                              {this.state.isCouponApplied ? (
                                <button
                                  className="btn custom-apply-btn"
                                  onClick={this.removeCouponCode}
                                  type="button"
                                >
                                  Remove
                                </button>
                              ) : (
                                <button
                                  className="btn custom-apply-btn"
                                  onClick={this.validateCouponCode}
                                  type="button"
                                  disabled={this.state.coupon.length == 0}
                                >
                                  Apply
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex-d gap-20">
                        <div className="w-100 mt-3">
                          <div className="additionl-box">
                            <label className="col-form-label colformlabel w-100">Customer Email (Optional)</label>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                              <input
                                type="email"
                                className={`form-control border-radius ${this.state.emailError ? 'is-invalid' : ''}`}
                                name="email"
                                id="email"
                                placeholder={`Customer Email`}
                                onChange={this.handleChange}
                                value={this.state.email}
                                style={
                                  this.state.emailError ? { borderColor: '#dc3545', width: '100%' } : { width: '100%' }
                                }
                              />
                              {this.state.emailError && (
                                <div
                                  style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px', textAlign: 'left' }}
                                >
                                  {this.state.emailError}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="w-100 d-flex mt-3 align-items-md-end align-items-center justify-content-center justify-content-md-end">
                          {this.state.isData ? (
                            <button className="btn btn-grd-disabled mr-2">Booking...!</button>
                          ) : (
                            <>
                              <button
                                onClick={this.onBooking}
                                className="btn book-btn btn-grd-disabled mr-2"
                              >
                                <i className="icofont icofont-save"></i>
                                Book
                                {/* <Link to={`/add-ons`}> Book</Link> */}
                              </button>
                              <button
                                onClick={this.clearData}
                                className="btn clear-btn btn-grd-disabled"
                              >
                                <i className="icofont icofont-clear"></i> Clear
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ConciergeCruiseAdd
